import {
  DatasetRoleID,
  DatasetUserResponse,
  UserResponse as LsUserResponse,
  ProjectRoleID,
  ProjectUserResponse,
} from '@backend/models';
import {fake} from '@fixtures/fake';
import {
  middlewareOrganizationFixtureFactory,
  mockLandingServiceOrganization,
  mockMiddlewareOrganization,
} from '@fixtures/organization';
import {getGetUserResponseMock, InstanceUserRoleID, UserResponse as MwUserResponse} from '@middleware';
import {cloneDeep} from 'lodash';

export const middlewareUserFixtureFactory = (overrides?: Partial<MwUserResponse>): MwUserResponse => {
  return getGetUserResponseMock({
    display_name: fake.person.fullName(),
    email: fake.internet.email(),
    eula_accepted_at: fake.date.recent().toISOString(),
    id: fake.string.uuid(),
    instance_user_role_id: InstanceUserRoleID.USER,
    organization: middlewareOrganizationFixtureFactory(),
    ...(overrides || {}),
  });
};

export const mockMiddlewareUserResponse: MwUserResponse = middlewareUserFixtureFactory({
  organization: cloneDeep(mockMiddlewareOrganization),
});

export const mockLandingServiceUserResponse: LsUserResponse = {
  id: fake.string.uuid(),
  email: fake.internet.email({
    provider: mockLandingServiceOrganization.email_domains[0] as string,
    allowSpecialCharacters: false,
  }),
  is_admin: true,
  organization: cloneDeep(mockLandingServiceOrganization),
};

export const mockDatasetUserResponse: DatasetUserResponse = {
  dataset_role_id: DatasetRoleID.ADMIN,
  user: cloneDeep(mockLandingServiceUserResponse),
};

export const mockProjectUserResponse: ProjectUserResponse = {
  is_project_pi: true,
  project_role_id: ProjectRoleID.OWNER,
  user: cloneDeep(mockLandingServiceUserResponse),
};
